import React, { useState } from "react";
import { ReactComponent as RightArrow } from "assets/svgs/right-arrow.svg";
import { ReactComponent as LeftArrow } from "assets/svgs/left-arrow.svg";
import { Swiper, SwiperSlide } from "components/swiper";
import { Thumbs } from "swiper";
import Image from "components/image";
import { useMediaQuery } from "react-responsive";
import { useSelector } from "react-redux";

const ImageSlideShow = ({ images }) => {
	const isDesktop = useMediaQuery({ query: "(min-width: 992px)" });
	const { isClient } = useSelector(state => state.global);

	const [thumbsSwiper, setThumbsSwiper] = useState(null);
	const controls = {
		slidesPerView: 1,
		preventClicks: true,
		preventClicksPropagation: false,
		noSwiping: true,
		freeMode: true,
		spaceBetween: 10,
		mousewheel: {
			enabled: true,
			forceToAxis: true,
		},
		slidesPerGroup: 1,
		thumbs: { swiper: thumbsSwiper },
		navigation: {
			enabled: true,
			nextEl: ".right-arrow-s",
			prevEl: ".left-arrow-s",
		},
		a11y: true,
	};

	const thumbSettings = {
		slidesPerView: 4,
		preventClicks: true,
		preventClicksPropagation: false,
		noSwiping: true,
		freeMode: true,
		spaceBetween: 15,
		mousewheel: {
			enabled: true,
			forceToAxis: true,
		},
		slidesPerGroup: 4,
		a11y: true,
	};

	return isClient && isDesktop ? (
		<>
			<div className="my-3">{images?.length > 0 && <Image image={images[0]?.asset} />}</div>
			{images?.length > 1 && (
				<div className="grid grid-cols-2 gap-5 my-3">
					{images?.slice(1)?.map((image, i) => (
						<div key={i} className="w-full">
							<Image key={image._key} image={image.asset} />
						</div>
					))}
				</div>
			)}
		</>
	) : (
		<>
			<Swiper {...controls}>
				{images?.map((i) => (
					<SwiperSlide key={i._key}>
						<Image image={i.asset} alt={i.alt} />
					</SwiperSlide>
				))}
				<div className="left-arrow-s [background:transparent]">
					<LeftArrow />
				</div>
				<div className="right-arrow-s [background:transparent]">
					<RightArrow />
				</div>
			</Swiper>
			<br />
			<Swiper modules={[Thumbs]}
				watchSlidesProgress onSwiper={setThumbsSwiper} {...thumbSettings} className="product-swiper-thumbs">
				{images?.map((i) => (
					<SwiperSlide key={i._key}>
						<Image image={i.asset} alt={i.alt} />
					</SwiperSlide>
				))}
			</Swiper>
		</>
	);
};

export default ImageSlideShow;
